import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SketchSquareFilledSvg from "@ant-design/icons-svg/es/asn/SketchSquareFilled";
import AntdIcon from "../components/AntdIcon";
var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SketchSquareFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SketchSquareFilled.displayName = 'SketchSquareFilled';
}
export default /*#__PURE__*/React.forwardRef(SketchSquareFilled);